/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Impact_Image_AltInputs */

const en_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf driver at the moment of impact`)
};

const es_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driver de golf en el momento del impacto`)
};

const de_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf-Driver im Treffmoment`)
};

const zh_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`击球瞬间的高尔夫一号木`)
};

const ar_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مضرب درايفر للغولف لحظة الاصطدام بالكرة`)
};

const fr_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driver de golf au moment de l'impact`)
};

const vi_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gậy driver golf vào khoảnh khắc chạm bóng`)
};

const sw_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fimbo ya gofu aina ya driver wakati wa kugonga mpira`)
};

const th_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม้ไดรเวอร์กอล์ฟในจังหวะที่กระทบลูก`)
};

const bs_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf driver u trenutku udarca`)
};

const ja_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インパクトの瞬間のゴルフドライバー`)
};

const ko_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`임팩트 순간의 골프 드라이버`)
};

const pt_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taco driver de golfe no momento do impacto`)
};

const it_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driver da golf nel momento dell'impatto`)
};

const sv_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfdriver i träffögonblicket`)
};

const nl_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfdriver op het moment van impact`)
};

const da_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfdriver i træfmomentet`)
};

const nb_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfdriver i treffmomentet`)
};

const fi_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfin draiveri osumahetkellä`)
};

const pl_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kij golfowy typu driver w momencie uderzenia piłki`)
};

const ru_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Драйвер для гольфа в момент удара по мячу`)
};

const tr_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topa vuruş anında golf driver sopası`)
};

const hi_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गेंद से टकराने के क्षण में गोल्फ़ ड्राइवर`)
};

const id_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stik driver golf pada saat impact`)
};

const ms_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kayu driver golf pada saat hentaman`)
};

const cs_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfový driver v okamžiku zásahu míčku`)
};

const el_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μπαστούνι driver του γκολφ τη στιγμή της επαφής με την μπάλα`)
};

const he_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחבט דרייבר של גולף ברגע הפגיעה בכדור`)
};

const af_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gholfdrywer op die oomblik van impak`)
};

const hu_home_impact_image_alt = /** @type {(inputs: Home_Impact_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf driver ütő a labdával való találkozás pillanatában`)
};

/**
* | output |
* | --- |
* | "Golf driver at the moment of impact" |
*
* @param {Home_Impact_Image_AltInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_impact_image_alt = /** @type {((inputs?: Home_Impact_Image_AltInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Impact_Image_AltInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_impact_image_alt(inputs)
	if (locale === "de") return de_home_impact_image_alt(inputs)
	if (locale === "zh") return zh_home_impact_image_alt(inputs)
	if (locale === "ar") return ar_home_impact_image_alt(inputs)
	if (locale === "fr") return fr_home_impact_image_alt(inputs)
	if (locale === "vi") return vi_home_impact_image_alt(inputs)
	if (locale === "sw") return sw_home_impact_image_alt(inputs)
	if (locale === "th") return th_home_impact_image_alt(inputs)
	if (locale === "bs") return bs_home_impact_image_alt(inputs)
	if (locale === "ja") return ja_home_impact_image_alt(inputs)
	if (locale === "ko") return ko_home_impact_image_alt(inputs)
	if (locale === "pt") return pt_home_impact_image_alt(inputs)
	if (locale === "it") return it_home_impact_image_alt(inputs)
	if (locale === "sv") return sv_home_impact_image_alt(inputs)
	if (locale === "nl") return nl_home_impact_image_alt(inputs)
	if (locale === "da") return da_home_impact_image_alt(inputs)
	if (locale === "nb") return nb_home_impact_image_alt(inputs)
	if (locale === "fi") return fi_home_impact_image_alt(inputs)
	if (locale === "pl") return pl_home_impact_image_alt(inputs)
	if (locale === "ru") return ru_home_impact_image_alt(inputs)
	if (locale === "tr") return tr_home_impact_image_alt(inputs)
	if (locale === "hi") return hi_home_impact_image_alt(inputs)
	if (locale === "id") return id_home_impact_image_alt(inputs)
	if (locale === "ms") return ms_home_impact_image_alt(inputs)
	if (locale === "cs") return cs_home_impact_image_alt(inputs)
	if (locale === "el") return el_home_impact_image_alt(inputs)
	if (locale === "he") return he_home_impact_image_alt(inputs)
	if (locale === "af") return af_home_impact_image_alt(inputs)
	if (locale === "hu") return hu_home_impact_image_alt(inputs)
	return en_home_impact_image_alt(inputs)
});